import type { Template } from "@/types";

export const PO_07_H3_V4: Template[] = [
{
    id: "po-07-h3v4-01",
    name: "PO 01 - H3V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h3_v4_01.png",
    size: [1217, 851],
    style: {},
        slots: [
            { id: "1", x: 43, y: 146, width: 524, height: 362, rotation: 0, imageRotation: 0 },
            { id: "2", x: 43, y: 516, width: 258, height: 188, rotation: 0, imageRotation: 0 },
            { id: "3", x: 309, y: 516, width: 258, height: 188, rotation: 0, imageRotation: 0 },
            { id: "4", x: 719, y: 147, width: 190, height: 275, rotation: 0, imageRotation: 0 },
            { id: "5", x: 719, y: 430, width: 190, height: 275, rotation: 0, imageRotation: 0 },
            { id: "6", x: 917, y: 147, width: 189, height: 275, rotation: 0, imageRotation: 0 },
            { id: "7", x: 917, y: 430, width: 189, height: 275, rotation: 0, imageRotation: 0 }
        ],
},

{
    id: "po-07-h3v4-02",
    name: "PO 02 - H3V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h3_v4_02.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 61, y: 173, width: 196, height: 164, rotation: 0, imageRotation: 0 },
        { id: "2", x: 61, y: 345, width: 196, height: 164, rotation: 0, imageRotation: 0 },
        { id: "3", x: 61, y: 517, width: 196, height: 163, rotation: 0, imageRotation: 0 },
        { id: "4", x: 265, y: 173, width: 299, height: 507, rotation: 0, imageRotation: 0 },
        { id: "5", x: 655, y: 173, width: 332, height: 507, rotation: 0, imageRotation: 0 },      
        { id: "6", x: 995, y: 173, width: 164, height: 250, rotation: 0, imageRotation: 0 },
        { id: "7", x: 995, y: 431, width: 164, height: 249, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h3v4-03",
    name: "PO 03 - H3V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h3_v4_03.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 35, y: 135, width: 546, height: 377, rotation: 0, imageRotation: 0 },      
        { id: "2", x: 35, y: 520, width: 269, height: 197, rotation: 0, imageRotation: 0 },
        { id: "3", x: 312, y: 520, width: 269, height: 197, rotation: 0, imageRotation: 0 },
        { id: "4", x: 634, y: 135, width: 408, height: 582, rotation: 0, imageRotation: 0 },
        { id: "5", x: 1050, y: 135, width: 131, height: 189, rotation: 0, imageRotation: 0 },
        { id: "6", x: 1050, y: 332, width: 131, height: 189, rotation: 0, imageRotation: 0 },
        { id: "7", x: 1050, y: 529, width: 131, height: 188, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h3v4-04",
    name: "PO 04 - H3V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h3_v4_04.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 130, y: 77, width: 348, height: 228, rotation: 0, imageRotation: 0 },
        { id: "2", x: 130, y: 313, width: 348, height: 227, rotation: 0, imageRotation: 0 },
        { id: "3", x: 130, y: 548, width: 348, height: 227, rotation: 0, imageRotation: 0 },
        { id: "4", x: 682, y: 77, width: 227, height: 345, rotation: 0, imageRotation: 0 },
        { id: "5", x: 682, y: 430, width: 227, height: 345, rotation: 0, imageRotation: 0 },
        { id: "6", x: 917, y: 77, width: 227, height: 345, rotation: 0, imageRotation: 0 },
        { id: "7", x: 917, y: 430, width: 227, height: 345, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h3v4-05",
    name: "PO 05 - H3V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h3_v4_05.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 55, y: 153, width: 496, height: 359, rotation: 0, imageRotation: 0 },
        { id: "2", x: 55, y: 520, width: 244, height: 178, rotation: 0, imageRotation: 0 },
        { id: "3", x: 307, y: 520, width: 244, height: 178, rotation: 0, imageRotation: 0 },
        { id: "4", x: 734, y: 153, width: 175, height: 269, rotation: 0, imageRotation: 0 },
        { id: "5", x: 917, y: 153, width: 175, height: 269, rotation: 0, imageRotation: 0 },
        { id: "6", x: 734, y: 430, width: 175, height: 269, rotation: 0, imageRotation: 0 },
        { id: "7", x: 917, y: 430, width: 175, height: 269, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h3v4-06",
    name: "PO 06 - H3V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h3_v4_06.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 85, y: 80, width: 440, height: 307, rotation: 0, imageRotation: 0 },    
        { id: "2", x: 85, y: 395, width: 216, height: 147, rotation: 0, imageRotation: 0 },
        { id: "3", x: 309, y: 395, width: 216, height: 147, rotation: 0, imageRotation: 0 },
        { id: "4", x: 85, y: 550, width: 142, height: 221, rotation: 0, imageRotation: 0 },
        { id: "5", x: 235, y: 550, width: 141, height: 221, rotation: 0, imageRotation: 0 },
        { id: "6", x: 384, y: 550, width: 141, height: 221, rotation: 0, imageRotation: 0 },
        { id: "7", x: 693, y: 80, width: 440, height: 690, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h3v4-07",
    name: "PO 07 - H3V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h3_v4_07.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 85, y: 234, width: 440, height: 308, rotation: 0, imageRotation: 0 },
        { id: "2", x: 309, y: 80, width: 216, height: 146, rotation: 0, imageRotation: 0 },
        { id: "3", x: 85, y: 80, width: 216, height: 146, rotation: 0, imageRotation: 0 },      
        { id: "4", x: 85, y: 550, width: 142, height: 221, rotation: 0, imageRotation: 0 },
        { id: "5", x: 235, y: 550, width: 141, height: 221, rotation: 0, imageRotation: 0 },
        { id: "6", x: 384, y: 550, width: 141, height: 221, rotation: 0, imageRotation: 0 },
        { id: "7", x: 693, y: 81, width: 440, height: 690, rotation: 0, imageRotation: 0 },
    ],
},

{
    id: "po-07-h3v4-08",
    name: "PO 08 - H3V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h3_v4_08.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 0, y: 201, width: 604, height: 447, rotation: 0, imageRotation: 0 },
        { id: "2", x: 613, y: 201, width: 299, height: 213, rotation: 0, imageRotation: 0 },
        { id: "3", x: 920, y: 201, width: 298, height: 213, rotation: 0, imageRotation: 0 },
        { id: "4", x: 613, y: 421, width: 146, height: 227, rotation: 0, imageRotation: 0 },
        { id: "5", x: 767, y: 421, width: 145, height: 227, rotation: 0, imageRotation: 0 },
        { id: "6", x: 920, y: 421, width: 145, height: 227, rotation: 0, imageRotation: 0 },
        { id: "7", x: 1073, y: 421, width: 145, height: 227, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h3v4-09",
    name: "PO 09 - H3V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h3_v4_09.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 0, y: 218, width: 255, height: 413, rotation: 0, imageRotation: 0 },
        { id: "2", x: 263, y: 218, width: 168, height: 133, rotation: 0, imageRotation: 0 },
        { id: "3", x: 263, y: 359, width: 168, height: 132, rotation: 0, imageRotation: 0 },
        { id: "4", x: 263, y: 499, width: 168, height: 132, rotation: 0, imageRotation: 0 },
        { id: "5", x: 439, y: 218, width: 255, height: 413, rotation: 0, imageRotation: 0 },
        { id: "6", x: 702, y: 218, width: 254, height: 413, rotation: 0, imageRotation: 0 },
        { id: "7", x: 964, y: 218, width: 254, height: 413, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h3v4-10",
    name: "PO 10 - H3V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h3_v4_10.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 0, y: 223, width: 249, height: 405, rotation: 0, imageRotation: 0 },
        { id: "2", x: 257, y: 223, width: 249, height: 405, rotation: 0, imageRotation: 0 },
        { id: "3", x: 514, y: 223, width: 249, height: 405, rotation: 0, imageRotation: 0 },
        { id: "4", x: 771, y: 223, width: 248, height: 405, rotation: 0, imageRotation: 0 },
        { id: "5", x: 1027, y: 222, width: 192, height: 130, rotation: 0, imageRotation: 0 },
        { id: "6", x: 1027, y: 360, width: 192, height: 130, rotation: 0, imageRotation: 0 },
        { id: "7", x: 1027, y: 498, width: 192, height: 129, rotation: 0, imageRotation: 0 }
    ],
}
];